// Agent registry identifiers and integration grants (decision D20). Kept apart from agents.ts so
// config.ts can use them without an import cycle.
import { z } from "zod";
import { MODULE_CARD_ID_RE } from "./integration-modules.ts";

export const AGENT_KEY_RE = /^[a-z][a-z0-9-]{1,62}$/;
export const AGENT_SPECIALTY_RE = /^[a-z][a-z0-9-]{0,40}$/;
/** `<module>.<resource>.<action>` as declared by the module's operation catalogue. */
export const OPERATION_ID_RE = /^[a-z0-9]+(\.[a-z0-9_-]+)+$/;

/**
 * One integration operation an agent may call as a tool. v1 grants only `ler` and explicitly
 * listed `enviar` operations; `gerenciar` and `interna` operations are never tools (D20 condition 6).
 */
export const integrationGrantSchema = z
  .object({
    card_id: z.string().regex(MODULE_CARD_ID_RE),
    operation_id: z.string().regex(OPERATION_ID_RE).max(100),
    permission: z.enum(["ler", "enviar"]),
  })
  .strict();
export type IntegrationGrant = z.infer<typeof integrationGrantSchema>;
